import './App.css';

import CustomNavbar from './CustomNavbar.js';
import FooterComponent from './FooterComponent.js';
import HeaderComponent from './HeaderComponent.js';
import Homepage from './Homepage.js';
import ScrollToTop from './ScrollToTop.js';
import Curriculum from './Curriculum.js';
import { faFile, faMusic, faHands, faHouse } from '@fortawesome/free-solid-svg-icons';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Concerti from './Concerti.js';
import Lezioni from './Lezioni.js';

import { useTranslation } from 'react-i18next';

import homepageImage1 from './assets/Caterina_Vivarelli_pianista.png';
import homepageImage2 from './assets/Caterina_Vivarelli_Concerto1.png';
import homepageImage3 from './assets/Lezioni_Pianoforte1.png';
import BannerMetodo from './BannerMetodo.js';

function App() {

  const { t } = useTranslation("translation");

  const navbarItems = [
    { label: "Home", url: '/', icon: faHouse },
    { label: t("navbar.curriculum"), url: '/curriculum', icon: faFile },
    { label: t("navbar.concerti"), url: '/concerti', icon: faMusic },
    { label: t("navbar.lezioni"), url: '/lezioni', icon: faHands },
  ];

  const features = [
    {
    image: homepageImage1,
    title: t("navbar.curriculum"),
    link: '/curriculum'
    },
    {
    image: homepageImage2,
    title: t("navbar.didattica"),
    link: '/lezioni'
    },
    {
    image: homepageImage3,
    title: t("navbar.concerti"),
    link: '/concerti'
    },
  ];

  function bannerTradotto() {
    return (
      <BannerMetodo 
        title={t("Banner.title")} 
        author={t("Banner.author")} 
        description={t("Banner.description")} 
        download={t("Banner.download")} 
        currentPage={window.location.pathname}
      />
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <CustomNavbar navbarItems={navbarItems}></CustomNavbar>
      <Routes>
        <Route path="/" element={
          <>
            <HeaderComponent
              headerContent={[
                { title: 'Caterina Vivarelli'}
              ]}
            />
            <Homepage features={features} Banner={bannerTradotto()} />
          </>
        } />
        <Route path="/curriculum" element={
          <>
            <HeaderComponent
              headerContent={[
                { title: 'Curriculum'}
              ]}
            />
            <Curriculum></Curriculum>
          </>
        } />
        <Route path="/concerti" element={
          <>
            <HeaderComponent
              headerContent={[
                { title: t('navbar.concerti')}
              ]}
            />
            <Concerti></Concerti>
          </>
        } />
        <Route path="/lezioni" element={
          <>
            <HeaderComponent
              headerContent={[
                { title: t('navbar.didattica')}
              ]}
            />
            <Lezioni Banner={bannerTradotto()}></Lezioni>
          </>
        } />
      </Routes>
      <FooterComponent></FooterComponent>
    </Router>   
  );
}

export default App;
